// TODO: CONVERT TO TYPESCRIPT
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { StatesContext } from './StatesContext'

function serviceAreaText (supplier, states) {
  let serviceArea = 'Undefined'
  if (supplier.national || supplier.states.length >= 50) {
    serviceArea = 'All States'
  } else if (supplier.states.length === 1) {
    serviceArea = states.find((s) => s.code === supplier.states[0]).name
  } else if (supplier.states.length > 0) {
    serviceArea = 'Select States'
  }

  return serviceArea
}

export default function SupplierServiceArea ({ supplier }) {
  const states = useContext(StatesContext)
  const serviceArea = serviceAreaText(supplier, states)

  return (
    <div className='supplier-service-area'>
      <span className='title'>Service Area:</span> {serviceArea}
    </div>
  )
}

SupplierServiceArea.propTypes = {
  supplier: PropTypes.object.isRequired
}
